import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Marek W.",
    city: "Warszawa · Ausom Gallop",
    quote:
      "Przejechałem 118 km na jednym ładowaniu w okolicach Kampinosu. Fabryczna bateria w Gallopie wysiadała mi po 45 km. Aplikacja BMS pokazuje wszystko — nie ma większego komfortu niż wiedzieć dokładnie ile mi zostało.",
    rating: 5,
  },
  {
    name: "Kamil S.",
    city: "Kraków · Ausom Leopard",
    quote:
      "Mam serwis hulajnóg i przetestowaliśmy pakiety Celestii w warunkach polowych. Czysta robota — taśmy miedziane, plaster miodu, anti-spark działa bezbłędnie. Chińska konkurencja może się chować.",
    rating: 5,
  },
  {
    name: "Aleksandra P.",
    city: "Gdańsk · Ausom DT2 Pro",
    quote:
      "Najbardziej bałam się pożaru — naoglądałam się filmików. Po rozmowie z inżynierem i obejrzeniu jak budują pakiety, mam całkowity spokój. Montaż Plug & Play zajął 12 minut.",
    rating: 5,
  },
  {
    name: "Tomek R.",
    city: "Poznań · Ausom Gosoul 2",
    quote:
      "Voltage sag praktycznie zniknął. Hulajnoga ciągnie pod górkę tak samo na 100% jak na 30%. Cena Early Bird sprawiła, że to po prostu opłacalny upgrade.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      className="relative px-5 sm:px-8 lg:px-16 py-20 sm:py-28 max-w-7xl mx-auto"
    >
      <div className="flex items-center gap-3 mb-5">
        <span className="text-[#B026FF]">
          <svg viewBox="0 0 24 24" className="w-3 h-3" fill="currentColor">
            <path d="M12 1.5 L13.6 10.4 L22.5 12 L13.6 13.6 L12 22.5 L10.4 13.6 L1.5 12 L10.4 10.4 Z" />
          </svg>
        </span>
        <span className="uppercase tracking-[0.28em] text-[11px] text-[#B026FF] font-semibold">
          Co mówią pierwsi testerzy
        </span>
      </div>

      <h2
        className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white max-w-3xl"
        data-testid="testimonials-h2"
      >
        Polscy <span className="text-[#B026FF]">testerzy</span> już jeżdżą na Celestii.
      </h2>
      <p className="mt-5 text-[#A69CBB] max-w-2xl">
        Wybrane opinie z fazy beta-testów (sezon 2025). Pełne nazwiska oraz wideo testimoniale
        opublikujemy w dniu premiery.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-12">
        {TESTIMONIALS.map((t, i) => (
          <div
            key={i}
            className="industrial-card armor-corners relative p-7 rounded-md"
            data-testid={`testimonial-card-${i}`}
          >
            <span className="corner tl" />
            <span className="corner tr" />
            <span className="corner bl" />
            <span className="corner br" />
            <div className="shine-line" />

            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-1">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star
                    key={k}
                    className="w-4 h-4 text-[#B026FF]"
                    fill="currentColor"
                  />
                ))}
              </div>
              <Quote className="w-6 h-6 text-[#B026FF]/30" />
            </div>

            <p className="text-[15px] text-[#C9C1DA] leading-relaxed">
              „{t.quote}"
            </p>

            <div className="mt-6 pt-5 border-t border-white/5 flex items-center justify-between">
              <div>
                <div className="text-sm font-bold text-white">{t.name}</div>
                <div className="text-xs text-[#756B8A] mt-0.5">{t.city}</div>
              </div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#756B8A]">
                Beta · 2025
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
